import { Box, Typography } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import { GlobalContext } from "../../../../common/Context";
import CheckIcon from "@mui/icons-material/Check";
import {
  background,
  green,
  purple,
  red,
  white,
} from "../../../../../theme/colours";
import { hexToRGBA } from "../../../../common/Utils/Utils";

const CoinCard = ({ week, data, page, visibleAmt }) => {
  const { mobileView, desktopView } = useContext(GlobalContext);

  const [status, setStatus] = useState();

  useEffect(() => {
    let missed = data?.entriesMissed.filter(
      (entry) => entry === week + visibleAmt * page,
    );
    let won = data?.entriesWon.filter(
      (entry) => entry === week + visibleAmt * page,
    );
    setStatus(missed.length > 0 ? "fail" : won.length > 0 ? "pass" : null);
  }, [page]);

  const coinBoxStyle = {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "column",
    aspectRatio: "1/1",
    width: mobileView ? "22%" : "23.5%",
    height: "fit-content",
    borderRadius: "10px",
    border:
      week === data.entriesAvailable[0]
        ? `3px solid ${purple[1]}`
        : `2px solid ${background.primary}`,
    mb: week <= visibleAmt / 2 && "2%",
    background:
      status === "pass"
        ? `linear-gradient(137deg, ${purple[1]} 0%, ${green[2]} 100%)`
        : white,
    mr:
      week % (visibleAmt / 2) &&
      (mobileView ? "2.5%" : desktopView ? "2%" : "2%"),
  };
  const checkBoxStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "1.25rem",
    height: "1.25rem",
    backgroundColor: white,
    borderRadius: "3px",
    position: "relative",
    left: "7.5%",
    bottom: "70%",
    boxShadow: "0px 2px 3px 1px #dad8e8",
    zIndex: 1,
  };
  const topCoinAreaStyle = {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: "20%",
  };
  const mainCoinAreaStyle = {
    aspectRatio: "1/1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "55%",
    borderRadius: "50%",
    backgroundColor:
      status === "fail" ? hexToRGBA(red[1], 0.35) : background.primary,
  };
  const failText = {
    fontWeight: 700,
    color: red[1],
  };
  const weekText = {
    fontWeight: 600,
    fontSize: "0.75rem",
    height: "20%",
    ...(status === "pass" && { color: white }),
  };
  const monboldText = {
    fontWeight: 700,
    ml: "0.25rem",
    mt: "0.25rem",
    ...(status === "pass" && { color: white }),
  };
  const checkStyle = {
    color: green[2],
    height: "1rem",
    width: "1rem",
  };

  return (
    <Box sx={coinBoxStyle}>
      <Box sx={topCoinAreaStyle}>
        {status !== "fail" && (
          <>
            <Typography sx={monboldText}>{`$ ${data.entryValue}`}</Typography>
            <Box sx={checkBoxStyle}>
              {status === "pass" && (
                <CheckIcon fontSize="large" sx={checkStyle} />
              )}
            </Box>
          </>
        )}
      </Box>
      <Box sx={mainCoinAreaStyle}>
        {status !== "fail" ? (
          <img
            alt={"Prize"}
            src={"images/Coin.svg"}
            width={"75%"}
            height="inherit"
          />
        ) : (
          <Typography sx={failText}>{`-$ ${data.entryValue}`}</Typography>
        )}
      </Box>
      <Typography sx={weekText}>{`Week ${
        week + visibleAmt * page
      }`}</Typography>
    </Box>
  );
};

export default CoinCard;
